import { render } from "./PortalPageHeader.vue?vue&type=template&id=e47fe4de&scoped=true"
import script from "./PortalPageHeader.vue?vue&type=script&lang=js"
export * from "./PortalPageHeader.vue?vue&type=script&lang=js"

import "./PortalPageHeader.vue?vue&type=style&index=0&id=e47fe4de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e47fe4de"]])

export default __exports__